{
  "title": "Thorn Whip",
  "source": "Player's Handbook",
  "levelAndSchool": "Transmutation cantrip",
  "level": 0,
  "castingTime": "1 action",
  "range": "30 feet",
  "components": "V, S, M (the stem of a plant with thorns)",
  "duration": "Instantaneous",
  "description": [
    "You create a long, vine-like whip covered in thorns that lashes out at your command toward a creature in range. Make a melee spell attack against the target. If the attack hits, the creature takes 1d6 piercing damage, and if the creature is Large or smaller, you pull the creature up to 10 feet closer to you.",
    "At Higher Levels. This spell’s damage increases by 1d6 when you reach 5th level (2d6), 11th level (3d6), and 17th level (4d6)."
  ],
  "spellLists": ["artificer", "druid"]
}
